import BasePeripheral from '@appblocks/codegeneration/Peripherals/_BasePeripheral';
import {
    CodeBlock, BlockType, SettingType, Setting,
} from '@appblocks/codegeneration/types';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';
import Peripherals from '@appblocks/codegeneration/Peripherals';

export default class Interrupt extends BasePeripheral {
    constructor() {
        super();
        this.id = 'int';
        this.name = 'Interrupt';
        this.requirements = ['board', 'tios'];
        const settings: Array<Setting> = [
            {
                id: 'INT',
                name: 'Int',
                settingType: SettingType.PIN,
                meta: 'INT',
                required: true,
                default: '',
            },
        ];
        this.settings = this.settings.concat(settings);
    }

    getCodeBlocks() {
        const blocks: Array<CodeBlock> = [];
        blocks.push({
            location: 'boot',
            blockType: BlockType.CODE,
            template: `
    'interrupt setup for ${(this.getSettingValue('NAME'))}
    io.intnum=${this.getSettingValue('NAME')}_INTERRUPT
    io.intenabled=YES`,
        });
        const interruptNumber = Peripherals.getInterrupt(this.getSettingValue('INT'), this.project.device.id);
        const interruptEnum = PlatformUtils.getEnum(interruptNumber, 'pl_int_num', this.project.device.platform);

        const interruptValue = PlatformUtils.getEnumValue(interruptNumber, 'pl_int_num', this.project.device.platform);
        const interruptBit = Math.pow(2, Number(interruptValue));
        blocks.push({
            location: 'on_io_int',
            blockType: BlockType.CODE,
            template: `
    if (linestate and ${interruptBit}) <>0 then
        'interrupt has been triggered by the interrupt ${this.getSettingValue('NAME')}_INTERRUPT
         
    end if
    `,
        });

        blocks.push({
            location: 'GLOBAL_CONSTS',
            blockType: BlockType.CODE,
            template: `
const ${this.getSettingValue('NAME')}_INTERRUPT=${interruptEnum}
            `,
        });
        return blocks;
    }

    getDetails(): string {
        return 'https://docs.tibbo.com/taiko/ser_port_int';
    }
}
